import React from "react";
import PropTypes from "prop-types";
import {
  stringToTicketStatus,
  TicketPhase,
  TicketStatus,
} from "../../../assets/js/AppTicketConstant";
import { actionsPropType } from "../../../models/ActionProp";
import { Button } from "@nextui-org/button";
import AppUserProfile from "../../../assets/js/AppUserProfile";

const ApproverActionButtons = ({
  ticketPhase,
  ticketStatus,
  ticketSequenceApproved,
  actions,
  data,
  actionType,
}) => {
  const userId = AppUserProfile.getData()["user_id"];

  const isInvalidApprover =
    ticketSequenceApproved.next_approver_user_id !== Number(userId);
  const isInvalidStatus =
    ticketStatus === TicketStatus.Rejected.value ||
    ticketStatus === TicketStatus.Approved.value ||
    ticketStatus === TicketStatus.Cancelled.value;

  const isDisableRoleAction = isInvalidApprover || isInvalidStatus;

  const handleAction = (actionFunc) => {
    if (typeof actionFunc === "function") {
      return () => actionFunc(data);
    }
    return undefined;
  };

  const approveButton = ({ isDisabled }) => {
    return (
      <Button
        key="approve_button"
        className={`w-24 font-medium !text-white text-nowrap ${
          isDisabled ? "bg-gray-400" : "bg-complete"
        }`}
        onPress={handleAction(actions?.approve?.onPress)}
        size="md"
        isDisabled={isDisabled}
      >
        อนุมัติ
      </Button>
    );
  };

  const rejectButton = ({ isDisabled }) => {
    return (
      <Button
        key="reject_button"
        className={`w-24 font-medium !text-white text-nowrap ${
          isDisabled ? "bg-gray-400" : "bg-error"
        }`}
        onPress={handleAction(actions?.reject?.onPress)}
        size="md"
        isDisabled={isDisabled}
      >
        ไม่อนุมัติ
      </Button>
    );
  };

  const paidButton = ({ isDisabled }) => {
    return (
      <Button
        key="paid_button"
        className={`w-fit font-medium !text-white text-nowrap ${
          isDisabled ? "bg-gray-400" : "bg-blue-500"
        }`}
        onPress={handleAction(actions?.paid?.onPress)}
        size="md"
        isDisabled={isDisabled}
      >
        ยืนยันการตรวจสอบงบ
      </Button>
    );
  };

  const renderActionButton = () => {
    switch (ticketPhase) {
      case TicketPhase.Proposal:
        switch (actionType) {
          case "approve":
            return approveButton({
              isDisabled:
                stringToTicketStatus(data.status.data) ===
                  TicketStatus.Approved ||
                stringToTicketStatus(data.status.data) ===
                  TicketStatus.Rejected ||
                isDisableRoleAction,
            });
          case "reject":
            return rejectButton({
              isDisabled:
                stringToTicketStatus(data.status.data) ===
                  TicketStatus.Approved ||
                stringToTicketStatus(data.status.data) ===
                  TicketStatus.Rejected ||
                isDisableRoleAction,
            });
          default:
            return null;
        }
      case TicketPhase.Management:
      case TicketPhase.Claim:
        switch (ticketStatus) {
          case TicketStatus.AwaitingApproval:
            switch (actionType) {
              case "approve":
                return approveButton({
                  isDisabled:
                    stringToTicketStatus(data.status.data) ===
                      TicketStatus.Approved || isDisableRoleAction,
                });
              case "reject":
                return rejectButton({
                  isDisabled:
                    stringToTicketStatus(data.status.data) ===
                      TicketStatus.Approved || isDisableRoleAction,
                });
              default:
                return null;
            }

          default:
            return null;
        }
      case TicketPhase.Accounting:
        return paidButton({
          isDisabled:
            stringToTicketStatus(data.status.data) === TicketStatus.Approved ||
            isDisableRoleAction,
        });
      default:
        return null;
    }
  };

  return renderActionButton();
};

ApproverActionButtons.propTypes = {
  ticketPhase: PropTypes.oneOf(Object.values(TicketPhase)).isRequired,
  ticketStatus: PropTypes.oneOf(
    Object.values(TicketStatus).map((status) => status.value)
  ).isRequired,
  actions: PropTypes.shape(actionsPropType).isRequired,
  data: PropTypes.any,
  actionType: PropTypes.oneOf(["approve", "reject"]).isRequired,
  ticketSequenceApproved: PropTypes.any,
};

export default ApproverActionButtons;
